import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    styled,
} from "@mui/material";
import { deactivateAccount, logout } from "../../stores/auth/authSlice";
import { useDispatch, useSelector } from "../../stores";
import { useEffect, useState } from "react";

import BottomBar from "../../components/BottomBar";
import LectureCard from "../../components/LectureCard";
import { selectLecturesAfterId } from "../../stores/lectures/lecturesSelectors";
import { selectUser } from "../../stores/auth/authSelectors";
import { useNavigate } from "react-router-dom";

const Profile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector(selectUser);
    
    const [open, setOpen] = useState(false);

    const lectures = useSelector(selectLecturesAfterId(15));

    useEffect(() => {
        if (!user.user) {
            navigate("/login");
        }
    }, [navigate, user]);

    const handleDelete = () => {
        dispatch(deactivateAccount(Number(user.user?.id) || 1));
        dispatch(logout())
        setOpen(false);
        navigate("/home")
    };

    return (
        <PageWrapper>
            {!!lectures.length && <Typography>محاضراتي</Typography>}

            {lectures.map((lecture) => (
                <LectureCard
                    key={lecture.id}
                    lecture={lecture}
                    showDeleteButton={true}
                />
            ))}

            <Button
                sx={{ backgroundColor: "secondary.main", marginTop: 10 }}
                onClick={() => {
                    dispatch(logout());
                    navigate("/home");
                }}
            >
                Logout
            </Button>

            <Box width="100%" display="flex" justifyContent="center">
                <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(true)}
                    sx={{
                        height: "20px",
                        marginBottom: 15,
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                >
                    <Typography fontSize="13px">Delete Account</Typography>
                </Button>
            </Box>

            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete your profile? This
                        action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDelete}
                        color="error"
                        variant="contained"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <BottomBar />
        </PageWrapper>
    );
};

export default Profile;

const PageWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minHeight: "100vh",
    backgroundImage: "url(/assets/tawhadi_background.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
    padding: 10,
    position: "relative",
});
